export { noWhitespaceValidator } from './no-whitespace.validator';
